"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TESTIMONIALS_DATA = void 0;
exports.TESTIMONIALS_DATA = {
    background_colour: '#f5f5f5',
    testimonials: [
        {
            organisation_name: 'Lucy & Yak',
            organisation_website_link: 'https://lucyandyak.com/',
            organisation_offset_earth_username: 'lucyandyak',
            person_name: 'via Instagram',
            testimony: "Ecologi is one of the most exciting things we've discovered this year!",
            image: {
                url: 'https://cms-assets.offset.earth/app/uploads/20200129122446/lucyandyak.png',
                link: 'https://x.wp.offset.earth/offset-earth-for-business/attachment/lucyandyak',
                alt: 'Lucy & Yak',
            },
        },
        {
            organisation_name: 'Star Editions',
            organisation_website_link: 'https://stareditions.com/',
            organisation_offset_earth_username: 'stareditions',
            person_name: 'Will Marston, CEO',
            testimony: "Ecologi perfectly resonates with our company ethos and we couldn't be prouder to be a part of this movement.",
            image: {
                url: 'https://cms-assets.offset.earth/app/uploads/20200129192700/star-logo-sq.png',
                link: 'https://x.wp.offset.earth/offset-earth-for-business/attachment/star-logo-sq',
                alt: 'Star Editions',
                icon: 'https://x.wp.offset.earth/wp/wp-includes/images/media/default.png',
            },
        },
        {
            organisation_name: 'Great State',
            organisation_website_link: 'https://www.greatstate.co/',
            organisation_offset_earth_username: 'greatstate',
            person_name: 'Victoria James, Director',
            testimony: "Ecologi was an absolute winner with our employees; it received the 'best benefit' award 2019.",
            image: {
                url: 'https://cms-assets.offset.earth/app/uploads/20200129193249/greatstate.png',
                link: 'https://x.wp.offset.earth/offset-earth-for-business/attachment/greatstate',
                alt: 'Great State',
            },
        },
    ],
    title: 'What our customers say',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVzdGltb25pYWxzLm1vY2suanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvX19tb2Nrc19fL3Rlc3RpbW9uaWFscy90ZXN0aW1vbmlhbHMubW9jay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlCQUFpQixHQUFxQjtJQUNqRCxpQkFBaUIsRUFBRSxTQUFTO0lBQzVCLFlBQVksRUFBRTtRQUNaO1lBQ0UsaUJBQWlCLEVBQUUsWUFBWTtZQUMvQix5QkFBeUIsRUFBRSx5QkFBeUI7WUFDcEQsa0NBQWtDLEVBQUUsWUFBWTtZQUNoRCxXQUFXLEVBQUUsZUFBZTtZQUM1QixTQUFTLEVBQ1Asd0VBQXdFO1lBQzFFLEtBQUssRUFBRTtnQkFDTCxHQUFHLEVBQUUsMkVBQTJFO2dCQUNoRixJQUFJLEVBQUUsMkVBQTJFO2dCQUNqRixHQUFHLEVBQUUsWUFBWTthQUNsQjtTQUNGO1FBQ0Q7WUFDRSxpQkFBaUIsRUFBRSxlQUFlO1lBQ2xDLHlCQUF5QixFQUFFLDJCQUEyQjtZQUN0RCxrQ0FBa0MsRUFBRSxjQUFjO1lBQ2xELFdBQVcsRUFBRSxtQkFBbUI7WUFDaEMsU0FBUyxFQUNQLDhHQUE4RztZQUNoSCxLQUFLLEVBQUU7Z0JBQ0wsR0FBRyxFQUFFLDZFQUE2RTtnQkFDbEYsSUFBSSxFQUFFLDZFQUE2RTtnQkFDbkYsR0FBRyxFQUFFLGVBQWU7Z0JBQ3BCLElBQUksRUFBRSxtRUFBbUU7YUFDMUU7U0FDRjtRQUNEO1lBQ0UsaUJBQWlCLEVBQUUsYUFBYTtZQUNoQyx5QkFBeUIsRUFBRSw0QkFBNEI7WUFDdkQsa0NBQWtDLEVBQUUsWUFBWTtZQUNoRCxXQUFXLEVBQUUsMEJBQTBCO1lBQ3ZDLFNBQVMsRUFDUCwrRkFBK0Y7WUFDakcsS0FBSyxFQUFFO2dCQUNMLEdBQUcsRUFBRSwyRUFBMkU7Z0JBQ2hGLElBQUksRUFBRSwyRUFBMkU7Z0JBQ2pGLEdBQUcsRUFBRSxhQUFhO2FBQ25CO1NBQ0Y7S0FDRjtJQUNELEtBQUssRUFBRSx3QkFBd0I7Q0FDaEMsQ0FBQyJ9